@if (showMasqueradeBanner) {
<div class="wbx-user-masquerade-overlay">
  <div class="wbx-full-container">
    <div class="wbx-user-masquerade-row">
      <div class="wbx-user-masquerade-contant">
        <p>{{ masqueradeBannerText }}</p>
      </div>
      <div class="wbx-user-masquerade-exit">
        <button
          type="button"
          class="wbx-user-masquerade-exit-btn"
          (click)="onExitMasqueradeClick($event)"
        >
          {{ translations.GLOBAL.KEYS.EXIT_BUTTON | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
}
<div *ngIf="showAddChallengeHeader" class="wbx-add-challenge-header" id="wbxAddChallengeHeader">
  <div class="wbx-full-container">
    <div class="wbx-add-challenge-header-row">
      <div class="wbx-team-back-btn">
        
        <a href="teams-admin.html" (click)="goToTeamsAdminTab($event)">
          {{ 'GLOBAL.KEYS.BACK' | translate }}
        </a>
      </div>
      <div class="wbx-add-challenge-header-message">
        <h6>
          @if (selectedChallengesCount === 0) {
            Select your challenges for the team
          } @else {
            {{ 'GLOBAL.KEYS.YOU_HAVE_SELECTED_THE_TEXT' | translate }} {{ selectedChallengesCount }} {{ 'GLOBAL.KEYS.CHALLENGES_TEXT' | translate }}
            {{ 'GLOBAL.KEYS.FOR_THIS_TEAM_TEXT' | translate }}
          }
        </h6>
        @if (selectedChallengesCount > 0) {
          <button
            class="wbx-add-challenge-header-message-join-btn"
            id="wbxAddChallengeHeaderJoinBtn"
            type="button"
            (click)="onJoinSelectedChallenges()"
          >
            {{ 'GLOBAL.KEYS_1_3.ADD_BUTTON' | translate }}
          </button>
        }
      </div>
    </div>
  </div>
</div>

<header class="wbx-header wbx-header-section"
  [style.top.px]="showMasqueradeBanner ? 59 : (showAddChallengeHeader ? 68 : null)">
    <div class="wbx-full-container">
      <div class="wbx-header-row">
        <div class="wbx-logo">
          <a [routerLink]="['/user/user-profile']" [queryParams]="{ tab: 'programs' }" >
            <img src="assets/images/logo.svg" alt="WBX">
          </a>
        </div>
        <div class="wbx-header-right">
          <div class="wbx-header-user-info">
            <ul>
              <li class="hide_mobile_menu">
                <a href="javascript:void(0)" class="hdr-notifications-menu wbx-hdr-menu-item" id="hdrMenuNotifications" (click)="toggleNotificationsPage()">
                  <i></i>
                  @if (unreadNotificationCount > 0) {
                    <span class="hdr-notifications-menu-count">{{ unreadNotificationCount }}</span>
                  }
                </a>
              </li>
              <li class="wbx-dropdown wbx-hdr-dropdown">
                <a
                  href="javascript:void(0)"
                  class="wbx-dropdown-toggle wbx-hdr-user-info wbx-hdr-menu-item"
                  id="hdrUserProfile"
                >
                  <app-cdn-image-loader
                    [defaultImage]="'/assets/images/wellbux-default-img/default-merchant.svg'"
                    [isCdnImage]="loginUser?.profileData && isImageCdnByImageType(loginUser.profileData.imageType)"
                    [src]="loginUser?.profileData ? getImageSrcByImageType(loginUser.profileData) : ''"
                    [height]="80"
                    [width]="80"
                  >
                  </app-cdn-image-loader>
                  <span>{{ loginUser?.fname || systemConstants.DEFAULT_USER_DISPLAY_NAME }}</span>
                </a>
                <div class="wbx-dropdown-outer">
                  <div class="wbx-dropdown-inner">
                    <div class="wbx-hdr-dropdown-actions">
                      <a class="wbx-hdr-dropdown-action-settings" [routerLink]="['/user/user-profile']" [queryParams]="{ tab: 'programs' }">
                        <i></i>
                        {{ 'GLOBAL.KEYS.MY_PROFILE_MENU' | translate }}
                      </a>
                      <a
                        class="wbx-hdr-dropdown-action-logout"
                        href="javascript:void(0)"
                        (click)="onLogout()"
                      >
                        <i></i>
                        {{ 'GLOBAL.KEYS.LOGOUT_MENU' | translate }}
                      </a>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
  
          <div class="wbx-menu">
            <ul>
              <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                <a [routerLink]="['/user/user-profile']" [queryParams]="{ tab: 'programs' }" class=" wbx-hdr-menu-item" id="hdrMenuHome">
                  <i class="hdr-dashboard-icon"></i>
                      {{ 'GLOBAL.KEYS.DASHBOARD_MENU' | translate }}
                </a>
              </li>
              <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                <a routerLink="/user/user-program" class=" wbx-hdr-menu-item" id="hdrMenuPrograms">
                  <i class="hdr-programs-icon"></i>
                  {{ 'GLOBAL.KEYS.PROGRAMS_MENU' | translate }}
                </a>
              </li>
              <li routerLinkActive="active" >
                <a routerLink="/user/user-teams" id="hdrMenuTeams" class="wbx-hdr-menu-item">
                  <i class="hdr-teams-icon"></i>
                  {{ 'GLOBAL.KEYS.TEAMS_MENU' | translate }}
                </a>
              </li>
              <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                <a routerLink="/user/user-tracker" id="hdrMenuTrackers" class="wbx-hdr-menu-item">
                  <i class="hdr-trackers-icon"></i>
                  {{ 'GLOBAL.KEYS.TRACKERS_MENU' | translate }}
                </a>
              </li>
              @if (isAdminPortalUser) {
              <li>
                <a
                  href="javascript:void(0)"
                  id="hdrMenuAdmin"
                  class="wbx-hdr-menu-item"
                  (click)="onAdminMenuClick($event)"
                >
                  <i class="hdr-admin-icon"></i>
                  {{ 'GLOBAL.KEYS.ADMIN_MENU' | translate }}
                </a>
              </li>
              }
            </ul>
          </div>
        </div>
  
        <div class="show_mobile_menu">
          <ul>
            <li>
              <a href="javascript:void(0);" class="hdr-notifications-menu" id="hdrMenuNotifications" (click)="toggleNotificationsPage()">
                <i class="drak-notifications-icon"></i>
                @if (unreadNotificationCount > 0) {
                  <span class="hdr-notifications-menu-count">{{ unreadNotificationCount }}</span>
                }
              </a>
            </li>
            <li>
              <button type="button" class="wbx-menu-toggle" id="mobileMenuToggle" (click)="toggleMobileMenu()">
                <img src="/assets/images/svg_icons/mobile_menu.svg" alt="Menu">
              </button>
            </li>
          </ul>
        </div>
  
        <div class="wbx-mobile-menus">
          <div class="wbx-mobile-menus-inner">
            <button type="button" class="wbx-mobile-menus-close" id="mobileMenuClose" (click)="closeMobileMenu()">
              <img src="/assets/images/svg_icons/nav-close-icon.svg" alt="Close">
            </button>
            <div class="wbx-mobile-menus-inner-content">
              <div class="wbx-mobile-user-info">
                <div class="wbx-mobile-user-info-img">
                  <img src="assets/images/demo/user-profile-img.jpg" alt="User Profile">
                </div>
                <div class="wbx-mobile-user-info-name">
                  {{ loginUser?.fname || systemConstants.DEFAULT_USER_DISPLAY_NAME }}
                </div>
              </div>
              <div class="wbx-mobile-menus-inner-content-menu">
                <ul>
                  <li>
                    <a [routerLink]="['/user/user-profile']" [queryParams]="{ tab: 'programs' }" id="mobileMenuPrograms" (click)="closeMobileMenu()">
                      <i class="wbx-mobile-settings-icon"></i>  {{ 'GLOBAL.KEYS.MY_PROFILE_MENU' | translate }}
                    </a>
                  </li>
                  <li>
                    <a [routerLink]="['/user/user-profile']" [queryParams]="{ tab: 'programs' }" class=" wbx-hdr-menu-item" id="hdrMenuHome" (click)="closeMobileMenu()">
                      <i class="hdr-dashboard-icon"></i>
                      {{ 'GLOBAL.KEYS.DASHBOARD_MENU' | translate }}
                    </a>
                  </li>
                  <li>
                    <a routerLink="/user/user-program" id="mobileMenuPrograms" (click)="closeMobileMenu()">
                      <i class="wbx-programs-icon"></i> {{ 'GLOBAL.KEYS.PROGRAMS_MENU' | translate }}
                    </a>
                  </li>
                  <li>
                    <a routerLink="/user/user-teams" id="mobileMenuTeams" (click)="closeMobileMenu()">
                      <i class="wbx-teams-icon"></i> {{ 'GLOBAL.KEYS.TEAMS_MENU' | translate }}
                    </a>
                  </li>
                  <li>
                    <a routerLink="/user/user-tracker" id="mobileMenuTrackers" (click)="closeMobileMenu()">
                      <i class="wbx-trackers-icon"></i> {{ 'GLOBAL.KEYS.TRACKERS_MENU' | translate }}
                    </a>
                  </li>
                  @if (isAdminPortalUser) {
                  <li>
                    <a
                      href="javascript:void(0)"
                      id="mobileMenuAdmin"
                      (click)="onAdminMenuClick($event)"
                    >
                      <i class="wbx-admin-icon"></i> {{ 'GLOBAL.KEYS.ADMIN_MENU' | translate }}
                    </a>
                  </li>
                  }
                  <li>
                    <a
                    class="wbx-hdr-dropdown-action-logout"
                    href="javascript:void(0)" 
                    (click)="onLogout()"
                  >
                    <i class="wbx-mobile-logout-icon"></i>
                    {{ 'GLOBAL.KEYS.LOGOUT_MENU' | translate }}
                  </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
  
      </div>
    </div>
  </header>
@if(isNotificationsPage){
  <section class="wbx-details-section wbx-details-sm-section wbx-notifications-details-section" style="top: 64px; height: calc(100vh - 64px); z-index: 10;">
				<ng-scrollbar class="wbx-details-section-content details-section-scroll wbx-user-scrollbar">
					<div class="wbx-details-section-inner">
						<div class="wbx-details-section-inner-top">
							<h1>
									{{ translations.GLOBAL.KEYS_1_3.NOTIFICATIONS_TEXT | translate }}
							</h1>
							<div class="wbx-notifications-custom-date-filter-box">
								<div
									class="wbx-custom-date-filter"
									[class.wbx-custom-date-filter-dropdown-show]="isNotificationDateFilterDropdownOpen"
								>
									<button
										type="button"
										class="wbx-custom-date-filter-toggle"
										(click)="toggleNotificationDateFilterDropdown()"
									>
										{{ translations.GLOBAL.KEYS_1_3.DATE_FILTER_BUTTON | translate }}
									</button>
									<div class="wbx-custom-date-filter-dropdown">
										<div class="wbx-custom-date-filter-dropdown-inner">
											<ul class="wbx-custom-date-filter-dropdown-inner-list">
												<li>
													<button type="button" (click)="setNotificationDateFilter('all')">
														{{ translations.GLOBAL.KEYS_1_3.ALL_BUTTON | translate }}
													</button>
												</li>
												<li>
													<button type="button" (click)="setNotificationDateFilter('weeks')">
													{{2}} {{ translations.GLOBAL.KEYS_1_3.WEEKS_AGO_TEXT | translate }}
													</button>
												</li>
												<li>
													<button type="button" (click)="setNotificationDateFilter('months')">
														{{3}} {{ translations.GLOBAL.KEYS_1_3.MONTHS_AGO_TEXT | translate }}
													</button>
												</li>
												<li>
													<button type="button" (click)="setNotificationDateFilter('months3')">
														 {{6}} {{ translations.GLOBAL.KEYS_1_3.MONTHS_AGO_TEXT | translate }}
													</button>
												</li>
												<li>
													<button type="button" (click)="setNotificationDateFilter('custom')">
														{{ translations.GLOBAL.KEYS_1_3.CUSTOM_BUTTON | translate }} <i class="wbx-gray-calendar-icon"></i>
													</button>
												</li>
											</ul>

											@if (selectedNotificationDateFilter === 'custom') {
												<div class="wbx-custom-notifications-range"> 
                          <div class="wbx-custom-notifications-range-items">
                            <div class="wbx-custom-notifications-range-item">
                              <label>{{ translations.GLOBAL.KEYS_1_3.START_DATE_LABEL | translate }}</label>
                              <input
                                type="text"
                                bsDatepicker
                                placement="bottom right"
                                placeholder="Start Date"
                                [(ngModel)]="customStartDate"
                                (ngModelChange)="applyCustomDateRange()"
                              />
                            </div>
                            <div class="wbx-custom-notifications-range-item">
                              <label>{{ translations.GLOBAL.KEYS_1_3.END_DATE_LABEL | translate }}</label>
                              <input
                                type="text"
                                bsDatepicker
                                placement="bottom right"
                                placeholder="End Date"
                                [(ngModel)]="customEndDate"
                                (ngModelChange)="applyCustomDateRange()"
                              />
                            </div>
                          </div>
													
												</div>
											}
										</div>
									</div>
								</div>
							</div>
						
							<button class="wbx-details-section-close" id="wbxDetailsSectionClose" (click)="toggleNotificationsPage()"></button>
						</div>
						<div class="wbx-details-section-inner-btm margin-top-20">
						   <div class="wbx-notifications-details-items">
								@if (isNotificationsLoading) {
									<div class="wbx-notifications-details-empty">Loading...</div>
								} @else if (notificationList?.length) {
									@for (notification of notificationList; track notification._id) {
										<div class="wbx-notifications-details-item">
											<div class="wbx-notifications-details-item-image">
                        <app-cdn-image-loader
                                    [defaultImage]="'/assets/images/wellbux-default-img/default-user.svg'"
                                    [isCdnImage]="notification.isAnnouncement ? false : isImageCdnByImageType(notification.media.imageType)"
                                    [src]="notification.isAnnouncement ? '/assets/images/wellbux-default-img/default-announcement.svg' : getImageSrcByImageType(notification.media)"
                                    [height]="80"
                                    [width]="80">
                                  </app-cdn-image-loader>
											</div>
											<div class="wbx-notifications-details-item-content">
												<button
													type="button"
													class="wbx-notifications-details-item-remove-btn"
													(click)="removeNotification(notification._id, $event)"
												></button>
												<p [innerHTML]="notification.message" [style.font-weight]="notification.isNotificationRead ? 'normal' : 'bold'"></p>
												<span class="wbx-notifications-details-item-time">
													{{ notification.createdDate | dateToMinutes }}
												</span>
											</div>
										</div>
									}
								} @else {
									<div class="wbx-notifications-details-empty">No notifications</div>
								}
						   </div>
						</div>
					</div>
				</ng-scrollbar>
			</section>
    }
